import Series from '../entities/Series.js'

class SeriesConverterBase {
    /**
     * Allows to convert single series
     * @param {Series} series - data series to convert
     */
    convertSingle(series) {
        if (!(series instanceof Series)) {
            throw new TypeError('series must be an instance inheriting from Series class');
        }

        return this._convert(series);
    }

    /**
     * Allows to convert multiple series
     * @param  {...Series} series 
     */
    convertMany(...series) {
        return series.map(s => this.convertSingle(s));
    }

    /**
     * Private method, which needs to be implemented in inheriting class
     * @param {Series} series - data series which will be converted
     */
    _convert(series) {
        throw new Error('Not implemented');
    }
}

export default SeriesConverterBase;